import React from 'react';

interface IDegenCollectionCardProps {
  thumbnail: string;
  title: string;
  onClick: () => void;
}

export const DegenCollectionCard = ({ thumbnail, title, onClick }: IDegenCollectionCardProps) => {
  return (
    <div className="card select-collection-card degen-collection-card" onClick={onClick}>
      <img className="card-img-top" src={thumbnail} alt="Card image cap" />
      <div className="card-body">
        <h3 className="card-title card-lead">{title}</h3>
      </div>
    </div>
  );
};
